import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { server } from "src/coreConfig";
import { setUrbinState } from "src/slices/urbin";
import { useDispatch, useSelector } from "src/store";
import axiosInstance from "src/utils/axios";
import { handleDownloadFile } from "src/utils/dataRenders";

const urls = {
  urban_request: {
    list: `${server}/api/v2/urbin/urban_request/list/`,
    new: `${server}/api/v2/urbin/urban_request/new/`,
    get: `${server}/api/v2/urbin/urban_request/get/`,
    update: `${server}/api/v2/urbin/urban_request/update/`,
    delete: `${server}/api/v2/urbin/urban_request/delete/`,
    addFile: `${server}/api/v2/urbin/urban_request/addFile/`,
    getFile: `${server}/api/v2/urbin/urban_request/getFile/`,
    deleteFile: `${server}/api/v2/urbin/urban_request/deleteFile/`,
  },
  urban_penalty: {
    addType: `${server}/api/v2/urbin/urban_penalty/addType/`,
    add: `${server}/api/v2/urbin/urban_penalty/add/`,
    list: `${server}/api/v2/urbin/urban_penalty/list/`,
    get: `${server}/api/v2/urbin/urban_penalty/get/`,
    update: `${server}/api/v2/urbin/urban_penalty/update/`,
    delete: `${server}/api/v2/urbin/urban_penalty/delete/`,
    addFile: `${server}/api/v2/urbin/urban_penalty/addFile/`,
    deleteFile: `${server}/api/v2/urbin/urban_penalty/deleteFile/`,
    downloadFile: `${server}/api/v2/urbin/urban_penalty/downloadFile/`,
    listTypes: `${server}/api/v2/urbin/urban_penalty/listTypes/`,
    updateTypes: `${server}/api/v2/urbin/urban_penalty/updateTypes/`,
  },
  configuration: `${server}/api/v2/urbin/configuration/`,
  handle: `${server}/api/v2/urbin/handle/`,
};
const useUrbinRequest = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [isDataError, setIsDataError] = useState(false);
  const { currentCustomer } = useSelector((state) => state.customers);
  const { adminMode } = useSelector((state) => state.settings);

  const [urbinRequestState, setUrbinRequestState] = useState({
    urbanProducts: null,
    currentUrbanRequest: null,
    urbanRequests: null,
    searchResults: null,
    isSearching: false,
    isLoading: false,
    isDeleted: false,
    errorMessages: [],
  });

  const { currentUrbanRequest, urbanRequests, urbanPenalties } = useSelector(
    (state) => state.urbin
  );
  const [res, setRes] = useState(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const api = async (url, data, options, label) => {
    var _res = loadData(url, data, options, label);
    return _res;
  };

  const requestData = async (url, data, options, label, customMessage) => {
    var _res = await loadData(url, data, options, label, customMessage);
    console.log("requestData", _res);
    if (_res.data?.res === 1) {
      setRes({ ..._res.data, status: _res.status });
    } else {
      setRes(_res);
    }
  };

  const loadData = async (url, data, options, label, customMessage) => {
    if (isLoading) return;
    setIsLoading(true);
    if (label) {
      var sb = enqueueSnackbar(customMessage || t("Obteniendo") + " " + label, {
        variant: "info",
      });
    }
    try {
      var res = await axiosInstance.post(url, data, options);
      if (label) closeSnackbar(sb);
      setIsLoading(false);
      if (options && options.responseType === "blob") {
        return res;
      }
      if (res.data.res === 1) {
        if (label) {
          enqueueSnackbar(label + " " + t("cargado exitosamente."), {
            variant: "success",
          });
        }
        return res;
      } else {
        setIsDataError(true);

        enqueueSnackbar(
          res.data.message || res.data.error || `${label} : error`,
          {
            variant: "error",
          }
        );
        return res;
      }
    } catch (e) {
      console.log(e);
      if (options && options.responseType === "blob") {
        var _d = await e.data.text();
        var _data = JSON.parse(_d);
        enqueueSnackbar(_data.message || `${label} : error`, {
          variant: "error",
        });
        setIsDataError(true);
        setIsLoading(false);
        return;
      }

      setIsLoading(false);
      setIsDataError(true);
      enqueueSnackbar(
        (e.data && e.data.message) ||
          e.message ||
          e.statusText ||
          `${label} : error`,
        { variant: "error" }
      );
      return e;
    }
  };

  const newUrbinRequest = async (data) => {
    return await api(
      urls.urban_request.new,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Creando solicitud")
    );
  };

  const loadProducts = async () => {
    var res = await api(
      urls.handle,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        instance: "product",
        action: "list",
      },
      {},
      null
    );
    dispatch(setUrbinState({ urbanProducts: res.data.data || [] }));
  };

  const adminListUrbanRequests = async (data) => {
    // disable this for using only the listUrbanRequests
    return listUrbanRequests(data);
  };

  const loadUserAddresses = async (ownerId) => {
    // var res = await api(arkadu.urls);
  };

  const getUrbanRequests = async (id) => {
    setUrbinRequestState((prev) => ({
      ...prev,
      errorMessages: [],
      isLoading: true,
    }));
    var res = await api(
      urls.urban_request.get,
      {
        id: id,
        instance: "request",
        action: "detail",
        mode: adminMode ? "admin" : "user",
        customer_id: currentCustomer.id,
      },
      {},
      t("Cargando detalle solicitud")
    );
    setUrbinRequestState((prev) => ({
      ...prev,
      isLoading: false,
    }));

    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanRequest: res.data.data || [] }));
      loadUserAddresses(res.data.data.owner_id);
    } else {
      dispatch(setUrbinState({ currentUrbanRequest: null }));
      setUrbinRequestState((prev) => ({
        ...prev,
        errorMessages: prev.errorMessages.concat(
          res.status === 404 ? t("Solicitud no encontrada") : res.data.message
        ),
      }));
    }
  };

  const listUrbanRequests = async (data) => {
    try {
      var res = await api(
        urls.urban_request.list,
        {
          customer_id: currentCustomer.id,
          mode: adminMode ? "admin" : "user",
          page_size: 25,
          page: 1,
          ...data,
        },
        {},
        null
      );
      if (res.data.res === 1) {
        dispatch(
          setUrbinState({
            urbanRequests: res.data.data || [],
            urbanRequestsCount: res.data.count || 0,
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const searchUrbanRequests = async (data) => {
    var res = await api(
      urls.urban_request.list,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        page_size: 50,
        page: 1,
        ...data,
      },
      {},
      t("Cargando solicitudes")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ searchResults: res.data.data || [] }));
    }
  };

  const clearSearchResults = async () => {
    dispatch(setUrbinState({ searchResults: null }));
  };

  const updateUrbinRequest = async (data) => {
    setUrbinRequestState((prev) => ({
      ...prev,
      errorMessages: [],
      isLoading: true,
    }));

    var res = await api(
      urls.urban_request.update,
      {
        id: currentUrbanRequest.id,
        area: currentUrbanRequest.area,
        phone: currentUrbanRequest.phone,
        address_id: currentUrbanRequest.address_id,
        description: currentUrbanRequest.description,
        address_text: currentUrbanRequest.address_text,
        ...data,
        instance: "request",
        action: "update",
        mode: adminMode ? "admin" : "user",
        customer_id: currentCustomer.id,
      },
      {},
      t("Actualizando solicitud")
    );
    setUrbinRequestState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanRequest: res.data.data || [] }));
    } else {
      setUrbinRequestState((prev) => ({
        ...prev,
        errorMessages: prev.errorMessages.concat(res.data.message),
      }));
    }
  };

  const deleteUrbinRequest = async () => {
    if (!currentUrbanRequest) return;
    if (!currentUrbanRequest.state == "draft") {
      enqueueSnackbar(
        t("No se puede eliminar una solicitud en estado diferente a borrador"),
        { variant: "error" }
      );
      return;
    }

    var res = await api(
      urls.urban_request.delete,
      {
        id: currentUrbanRequest.id,
        instance: "request",
        action: "delete",
        mode: adminMode ? "admin" : "user",
        customer_id: currentCustomer.id,
      },
      {},
      t("Eliminando solicitud")
    );
    if (res.data.res === 1) {
      enqueueSnackbar(t("Solicitud eliminada exitosamente"), {
        variant: "success",
      });
      setUrbinRequestState((prev) => ({
        ...prev,
        isDeleted: true,
      }));
      dispatch(setUrbinState({ currentUrbanRequest: null }));
    }
  };

  const addRequestFile = async (data) => {
    // build form data
    setUrbinRequestState((prev) => ({
      ...prev,
      errorMessages: [],
      isLoading: true,
    }));

    var formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    formData.append("id", currentUrbanRequest.id);
    formData.append("mode", adminMode ? "admin" : "user");
    formData.append("customer_id", currentCustomer.id);
    try {
      var res = await axiosInstance.post(urls.urban_request.addFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setUrbinRequestState((prev) => ({
        ...prev,
        isLoading: false,
      }));

      if (res.data.res === 1) {
        enqueueSnackbar(t("Archivo agregado exitosamente"), {
          variant: "success",
        });
        dispatch(setUrbinState({ currentUrbanRequest: res.data.data || [] }));
      } else {
        enqueueSnackbar(res.data.message, {
          variant: "error",
        });
        setUrbinRequestState((prev) => ({
          ...prev,
          errorMessages: prev.errorMessages.concat(res.data.message),
        }));
      }
    } catch (e) {
      enqueueSnackbar(e.message, {
        variant: "error",
      });
      setUrbinRequestState((prev) => ({
        ...prev,
        errorMessages: prev.errorMessages.concat(e.message),
        isLoading: false,
      }));
    }
  };

  const getRequestFile = async (fileId) => {
    var res = await api(
      urls.urban_request.getFile,
      {
        id: fileId,
        mode: adminMode ? "admin" : "user",
        customer_id: currentCustomer.id,
      },
      { responseType: "blob" },
      t("Obteniendo archivo")
    );
    handleDownloadFile(res);
  };

  const deleteRequestFile = async (fileId) => {
    setUrbinRequestState((prev) => ({
      ...prev,
      errorMessages: [],
      isLoading: true,
    }));

    var res = await api(
      urls.urban_request.deleteFile,
      {
        id: fileId,
        mode: adminMode ? "admin" : "user",
        customer_id: currentCustomer.id,
      },
      {},
      t("Eliminando archivo")
    );
    setUrbinRequestState((prev) => ({
      ...prev,
      isLoading: false,
    }));

    if (res.data.res === 1) {
      enqueueSnackbar(t("Archivo eliminado exitosamente"), {
        variant: "success",
      });
      dispatch(setUrbinState({ currentUrbanRequest: res.data.data || [] }));
    } else {
      enqueueSnackbar(res.data.message, {
        variant: "error",
      });
    }
  };

  // Start Penalty
  const addPenaltyType = async (data) => {
    var res = await api(
      urls.urban_penalty.addType,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Agregando tipo de sanción")
    );
    if (res.data.res === 1) {
      var types = [res.data.data, ...urbanPenaltiesTypes];

      dispatch(setUrbinState({ urbanPenaltiesTypes: types }));
    }
  };

  const addPenalty = async (data) => {
    var res = await api(
      urls.urban_penalty.add,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Agregando sanción")
    );
    if (res.data.res === 1) {
      dispatch(
        setUrbinState({
          currentUrbanPenalty: res.data.data,
          urbanPenalties: [res.data.data, ...urbanPenalties],
        })
      );
    }
    return res;
  };

  const listPenalties = async (data) => {
    var res = await api(
      urls.urban_penalty.list,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Listando sanciones")
    );
    if (res.data.res === 1) {
      dispatch(
        setUrbinState({
          urbanPenalties: res.data.data,
          urbanPenaltiesTypes: res.data.types,
          urbanPenaltiesCount: res.data.count,
        })
      );
    }
    return res;
  };

  const getPenalty = async (id) => {
    var res = await api(
      urls.urban_penalty.get,
      {
        id: id,
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      {},
      t("Obteniendo sanción")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanPenalty: res.data.data }));
    }
    return res;
  };

  const updatePenalty = async (data) => {
    var res = await api(
      urls.urban_penalty.update,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Actualizando sanción")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanPenalty: res.data.data }));
    }
    return res;
  };

  const deletePenalty = async (id) => {
    var res = await api(
      urls.urban_penalty.delete,
      {
        id: id,
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      {},
      t("Eliminando sanción")
    );
    if (res.data.res === 1) {
      var penalties = urbanPenalties.filter((p) => p.id !== id);
      dispatch(
        setUrbinState({
          urbanPenalties: penalties,
          currentUrbanPenalty: null,
        })
      );
    }
    return res;
  };

  const addPenaltyFile = async (data) => {
    var res = await api(
      urls.urban_penalty.addFile,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Agregando archivo de sanción")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanPenalty: res.data.data }));
    }
    return res;
  };

  const deletePenaltyFile = async (id) => {
    var res = await api(
      urls.urban_penalty.deleteFile,
      {
        id: id,
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      {},
      t("Eliminando archivo de sanción")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ currentUrbanPenalty: res.data.data }));
    }
  };

  const downloadPenaltyFile = async (id) => {
    var res = await api(
      urls.urban_penalty.downloadFile,
      {
        id: id,
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      { responseType: "blob" },
      t("Descargando archivo de sanción")
    );
    handleDownloadFile(res);
  };

  const listPenaltyTypes = async () => {
    var res = await api(
      urls.urban_penalty.listTypes,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      {},
      t("Listando tipos de sanción")
    );
    if (res.data.res === 1) {
      dispatch(setUrbinState({ urbanPenaltiesTypes: res.data.data }));
    }
  };

  const updatePenaltyTypes = async (data) => {
    var res = await api(
      urls.urban_penalty.updateTypes,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
        ...data,
      },
      {},
      t("Actualizando tipos de sanción")
    );
    if (res.data.res === 1) {
      var types = urbanPenaltiesTypes.map((t) => {
        if (t.id === data.id) {
          return data;
        }
        return t;
      });
      dispatch(setUrbinState({ urbanPenaltiesTypes: types }));
    }
  };

  //   "data": {
  //     "urban_products": [p.to_json() for p in urban_products],
  //     "urban_penalty_types": [
  //         p.to_json() for p in urban_penalty_types
  //     ],
  //     "urban_request_categories": [
  //         p.to_json() for p in urban_request_categories
  //     ],
  // },

  // End Penalty
  const getUrbinConfiguration = async () => {
    var res = await api(
      urls.configuration,
      {
        customer_id: currentCustomer.id,
        mode: adminMode ? "admin" : "user",
      },
      {},
      t("Obteniendo configuración")
    );
    if (res.data.res === 1) {
      dispatch(
        setUrbinState({
          urbanProducts: res.data.data.urban_products,
          urbanPenaltiesTypes: res.data.data.urban_penalty_types,
          urbanRequestCategories: res.data.data.urban_request_categories,
        })
      );
    }
  };

  useEffect(() => {
    if (currentCustomer) {
      listUrbanRequests();
    }
  }, [currentCustomer]);

  return {
    res,
    requestData,
    isLoading,
    api,
    newUrbinRequest,
    adminListUrbanRequests,
    loadProducts,
    getUrbanRequests,
    listUrbanRequests,
    searchUrbanRequests,
    clearSearchResults,
    updateUrbinRequest,
    deleteUrbinRequest,
    urbinRequestState,
    addRequestFile,
    getRequestFile,
    deleteRequestFile,
    penalties: {
      addPenaltyType,
      addPenalty,
      listPenalties,
      getPenalty,
      updatePenalty,
      deletePenalty,
      addPenaltyFile,
      deletePenaltyFile,
      downloadPenaltyFile,
      listPenaltyTypes,
      updatePenaltyTypes,
    },
    getUrbinConfiguration: getUrbinConfiguration,
  };
};

export default useUrbinRequest;

export { urls as urbinUrls };
